/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs */

const en_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Russet leaves, beautifully colored by the passage of time.`)
};

const ar_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوراق بنية، تلوَّنت بشكل جميل مع مرور الزمن.`)
};

const de_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotbraune Blätter, die sich im Laufe der Zeit schön verfärben.`)
};

const es_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hojas rojizas, bellamente coloreadas por el paso del tiempo.`)
};

const fr_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des feuilles rousses, magnifiées par le passage du temps.`)
};

const it_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglie color ruggine, splendidamente colorate dal passare del tempo.`)
};

const ja_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時の経過とともに美しく色づいた赤褐色の葉。`)
};

const ko_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시간의 흐름으로 아름답게 물든 적갈색 잎새들.`)
};

const pt_br_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folhas cor de ferrugem, belamente tingidas pela passagem do tempo.`)
};

const ru_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Красноватые листья, окрашенные в прекрасные цвета течением времени.`)
};

const th_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใบไม้สีน้ำตาลแดงที่งดงามจากการแต่งแต้มของกาลเวลา`)
};

const tr_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamanın geçmesiyle güzelce renklenen kırmızı yapraklar.`)
};

const zh_cn_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`橘红的羽叶，是时光荏苒的痕迹`)
};

const zh_tw_pro_user_appreciation_letter_bald_cypress_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`橘紅的羽葉，是時光荏苒的痕跡`)
};

/**
* | output |
* | --- |
* | "Russet leaves, beautifully colored by the passage of time." |
*
* @param {Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_bald_cypress_body1 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Bald_Cypress_Body1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_bald_cypress_body1(inputs)
	return zh_tw_pro_user_appreciation_letter_bald_cypress_body1(inputs)
});